import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  InputGroup,
  Alert,
  Spinner
} from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock, FaEye, FaEyeSlash, FaWallet, FaUserPlus } from 'react-icons/fa';
import 'assets/Login.css'; // File CSS tambahan untuk kustomisasi
import {login} from 'features/Auth/Wpauth'

const Login = () => {
  const navigate = useNavigate();
  
  // State untuk form dan UI
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const submitLoginForm = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setError('');
     login(formData)
     .then(
        function(){navigate('/')},
        function(error){
          console.error('Login error:', error);
          setError(
            
            'Login failed. Please check your credentials and try again.'
          );
        }
     )
     .finally(()=> {
      setIsLoading(false);
    })
  };

  return (
    <Container fluid className="login-container">
      <Row className="justify-content-center align-items-center min-vh-100">
        <Col xs={12} sm={10} md={8} lg={6} xl={5}>
          <Card className="login-card shadow-lg border-0">
            <Card.Header className="login-header bg-primary text-white text-center py-4">
              <div className="app-icon mb-3">
                <FaWallet size={30} />
              </div>
              <h2 className="fw-bold mb-1">Cashflow</h2>
              <p className="mb-0 opacity-75">by GROW team</p>
            </Card.Header>
            
            <Card.Body className="login-body p-4">
              {error && (
                <Alert variant="danger" className="mb-3">
                  {error}
                </Alert>
              )}
              
              <Form onSubmit={submitLoginForm}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Email</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FaUser />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="username"
                      value={formData.username}
                      onChange={handleInputChange}
                      placeholder="Enter your username"
                      required
                      disabled={isLoading}
                    />
                  </InputGroup>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Password</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FaLock />
                    </InputGroup.Text>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      placeholder="Enter your password"
                      required
                      disabled={isLoading}
                    />
                    <Button
                      variant="outline-secondary"
                      onClick={togglePasswordVisibility}
                      disabled={isLoading}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </Button>
                  </InputGroup>
                </Form.Group>

                <div className="d-flex justify-content-between align-items-center mb-4">
                  <Form.Check
                    type="checkbox"
                    id="remember-me"
                    label="Remember me"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    disabled={isLoading}
                  />
                  <a 
                    href={process.env.REACT_APP_WP_URL+"lost-password"}
                    className="text-decoration-none text-primary"
                  >
                    Forgot password?
                  </a>
                </div>

                <div className="d-grid gap-2 mb-3">
                  <Button
                    type="submit"
                    variant="primary"
                    size="lg"
                    disabled={isLoading}
                    className="fw-semibold"
                  >
                    {isLoading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Logging in...
                      </>
                    ) : (
                      'Login'
                    )}
                  </Button>
                </div>

                <div className="divider my-4">
                  <span className="px-2 text-muted">or</span>
                </div>

                <div className="d-grid gap-2">
                  <Button
                    href={process.env.REACT_APP_WP_URL+"register"}
                    variant="outline-primary"
                    size="lg"
                    className="fw-semibold"
                  >
                    <FaUserPlus className="me-2" />
                    Create New Account
                  </Button>
                </div>
              </Form>

              <div className="text-center mt-4">
                <small className="text-muted">
                  <a href={process.env.REACT_APP_WP_URL} className="text-decoration-none me-3">Home</a> • 
                  <a href={process.env.REACT_APP_WP_URL+"tentang-kami"} className="text-decoration-none mx-3">About Us</a> • 
                  <a href={process.env.REACT_APP_WP_URL+"bantuan"} className="text-decoration-none ms-3">Help</a>
                </small>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;